import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDialogStore = defineStore('dialog', {
  state: () => ({
    showBindPhone: ref(false),
    showRealNameAuth: false,
  }),
  actions: {
    openBindPhone() {
      this.showBindPhone = true
    },
    closeBindPhone() {
      this.showBindPhone = false
    },
    openRealNameAuth() {
      this.showRealNameAuth = true
    },
    closeRealNameAuth() {
      this.showRealNameAuth = false
    },
  },
})
